import { createApp } from "vue";
import App from "./App.vue";
import router from "./core/router";
import i18n from "@/core/i18n";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { defaultConfig, plugin } from "@formkit/vue";

import "@vuepic/vue-datepicker/dist/main.css";
import "@/assets/styles/index.css";

import config from "@/config";
import {
  setBackForwardNavigationGestures,
  setWebviewBounce,
} from "capacitor-plugin-ios-webview-configurator";
import { VueQueryPlugin } from "@tanstack/vue-query";

const app = createApp(App);

if (config.disableVueLogging) {
  // For some reason the default warning handler makes everything crash in iOS
  // (conflict with the capacitor console module?), because the
  // serializeConsoleMessage does not work for Vue Proxy objects
  app.config.errorHandler = (err) => console.error(err);
  app.config.warnHandler = (warn) => console.warn(warn);
}

app.use(router);
app.use(VueQueryPlugin);
app.use(i18n);
app.use(VueGoogleMaps, {
  load: {
    key: config.googleMapsApiKey,
  },
});

app.use(
  plugin,
  defaultConfig({
    messages: {
      en: {
        validation: {
          required({ name }) {
            const { t } = i18n.global;
            return t(`FormRequiredFieldError`);
          },
        },
      },
    },
  })
);

app.mount("#app");

app.config.unwrapInjectedRef = true;

setWebviewBounce(true);
setBackForwardNavigationGestures(true);
